import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="header">
      <div className="container">
        <div className="logo">
          <Link to="/">
            <h1>Kids Club Early Learning Center LLC</h1>
          </Link>
        </div>
        
        <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
          <div className="primary-nav">
            <Link to="/find-our-school" className="nav-link" onClick={() => setIsMenuOpen(false)}>Find Our School</Link>
            <Link to="/schedule-tour" className="nav-link" onClick={() => setIsMenuOpen(false)}>Schedule a Tour</Link>
            <Link to="/contact-us" className="nav-link" onClick={() => setIsMenuOpen(false)}>Contact Us</Link>
          </div>
          
          <div className="secondary-nav">
            <Link to="/curriculum" className="nav-link" onClick={() => setIsMenuOpen(false)}>Curriculum</Link>
            <Link to="/about" className="nav-link" onClick={() => setIsMenuOpen(false)}>About</Link>
            <Link to="/resources" className="nav-link" onClick={() => setIsMenuOpen(false)}>Resources</Link>
            <Link to="/blog" className="nav-link" onClick={() => setIsMenuOpen(false)}>Blog</Link>
            <Link to="/forms" className="nav-link" onClick={() => setIsMenuOpen(false)}>Forms</Link>
          </div>
        </nav>

        <button 
          className="menu-toggle"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          ☰
        </button>
      </div>
    </header>
  );
};

export default Header;